// cs2669 (Daniel, 29/10): banner da home COLADO no vídeo do topo e nas bordas da tela (sem as margens de
// 30px / 2,5% do NoveltyPieces), com a arte inteira na proporção natural e sem a caixa mínima de 500px,
// que deixava ~115px em branco antes do carrossel seguinte (Lançamentos). Vale para o carrossel
// (NoveltyPieces) e para o 1º slide do HTML do servidor (NoveltyPiecesSsr). Zero diff para os demais.
const BANNER_HOME_COLADO = new Set([2669]);

export const bannerHomeColado = (site: any): boolean => BANNER_HOME_COLADO.has(Number(site?.id));
